export const FILTER_FACET = 'facet';

// Api keywords filters
export const API_FILTER_SIZE = 'size';
export const API_FILTER_AFTER = 'after';

// Filter types
export const FILTER_TYPE_INPUT = 'input';
export const FILTER_TYPE_DATE_RANGE = 'dateRange';
export const FILTER_TYPE_DATE_YEAR = 'dateYear';
export const FILTER_TYPE_SELECT = 'select';
export const FILTER_TYPE_DATERANGE = 'dateRange';
export const FILTER_TYPE_MULTI_SELECT = 'multiSelect';

export const SEARCH_MIN_LENGTH = 2;
export const SEARCH_RESET_LENGTH = 0;
export const SEARCH_DEBOUNCE_TIME = 200;
